import { MultipleChoiceGroup } from '@ulysses-inc/harami_api_client'
import { useState } from 'react'
import MultipleChoiceDrawer from 'src/features/templateEdit/itemAppender/ResponseDropDown/components/MultipleChoiceDrawer/MultipleChoiceDrawer'

type Options = {
  /**
   * ドロワーの z-index。MUI Popover の上で開く場合(表の回答形式選択)など、
   * 既定の 1100 では下に潜るケースで上書きする。
   */
  zIndex?: number
}

/**
 * 選択肢ドロワーの表示ロジックとレンダリングをカプセル化するrender hook。
 */
export const useMultipleChoiceDrawer = (options?: Options) => {
  const [isVisible, setIsVisible] = useState(false)
  const [updateMultipleChoiceGroup, setUpdateMultipleChoiceGroup] =
    useState<MultipleChoiceGroup>()
  const [isTemplateSpecific, setIsTemplateSpecific] = useState(false)

  const open = (
    multipleChoiceGroup?: MultipleChoiceGroup,
    templateSpecific?: boolean,
  ) => {
    setUpdateMultipleChoiceGroup(multipleChoiceGroup)
    setIsTemplateSpecific(templateSpecific ?? false)
    setIsVisible(true)
  }

  const close = () => {
    setIsVisible(false)
    setUpdateMultipleChoiceGroup(undefined)
    setIsTemplateSpecific(false)
  }

  const renderDrawer = () => (
    <MultipleChoiceDrawer
      onClose={close}
      isVisible={isVisible}
      updateMultipleChoiceGroup={updateMultipleChoiceGroup}
      isTemplateSpecific={isTemplateSpecific}
      zIndex={options?.zIndex}
    />
  )

  return {
    open,
    close,
    renderDrawer,
    isVisible,
  }
}
